/** @format */

import "../App.css";
import React, { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cursosFinalizadosDispatchStart,
  cursosFinalizadosDispatchSuccess,
} from "../redux/slices/userSlice";
import { MenuCursos } from "../Components/Cursos/MenuCursos";
import { CursosDisponibles } from "./CursosDisponibles";
import { Spinner } from "react-bootstrap";

const Cursos = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.id);
  const contador = useSelector((state) => state.contador);
  const isLoadingFinalizados = useSelector(
    (state) => state.isLoadingFinalizados
  );
  const [cursosFinalizados, setCursosFinalizados] = useState([]);
  const [cursosActuales, setCursosActuales] = useState([]);
  const [isActive, setIsActive] = useState("actuales");
  const path = useSelector((state) => state.sitePath);

  useEffect(() => {
    dispatch(cursosFinalizadosDispatchStart());
    const obj = {
      id: user,
    };
    axios
      .post(path + "/cursosFinalizados.php", obj)
      .then((res) => {
        if (res.data === "Error") {
          dispatch(cursosFinalizadosDispatchSuccess([]));
        } else {
          setTimeout(() => {
            dispatch(cursosFinalizadosDispatchSuccess(res.data));
          }, 2000);
          setCursosFinalizados(res.data);
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
    axios
      .post(path + "/cursosActuales.php", obj)
      .then((res) => {
        if (res.data === "error") {
          // console.log(res.data);
        } else {
          setCursosActuales(res.data);
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [contador]);
  return (
    <section
      id='card-us'
      className='card-us section'
    >
      <div className='container'>
        <ul className='nav mb-5'>
          <li className='nav-item'>
            <button
              className={`btn mx-2 ${
                isActive === "actuales" ? "btn-primary" : "btn-light"
              }`}
              onClick={() => setIsActive("actuales")}
            >
              Actuales
            </button>
          </li>

          <li className='nav-item'>
            <button
              className={`btn mx-2 ${
                isActive === "finalizados" ? "btn-primary" : "btn-light"
              }`}
              onClick={() => setIsActive("finalizados")}
            >
              Finalizados
            </button>
          </li>
          <li className='nav-item'>
            <button
              className={`btn mx-2 ${
                isActive === "disponibles" ? "btn-primary" : "btn-light"
              }`}
              onClick={() => setIsActive("disponibles")}
            >
              Cursos disponibles
            </button>
          </li>
        </ul>

        <div className='row align-items-center'>
          {isActive === "disponibles" ? (
            isLoadingFinalizados ? (
              <div className='m-5 d-flex justify-content-center'>
                <Spinner />
              </div>
            ) : (
              <CursosDisponibles />
            )
          ) : (
            <MenuCursos
              isActive={isActive}
              cursosFinalizados={cursosFinalizados}
              cursosActuales={cursosActuales}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default Cursos;
